var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVillageIcon = function SvgVillageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14h3v-1.585A1.5 1.5 0 0 1 13 11V6a1.5 1.5 0 0 1 3 0v5a1.5 1.5 0 0 1-1 1.415V14h2v1.5H1V14h1V7.741q0-.136.05-.258a.6.6 0 0 1 .143-.206l4-3.653A.46.46 0 0 1 6.5 3.5c.111 0 .22.044.307.124l4 3.653q.091.084.142.206c.034.08.051.169.051.258zm-5.5 0V9.802h2V14z"
  })));
};
export default SvgVillageIcon;